import { Link } from '@tanstack/react-router'
import { TreePalmIcon } from 'lucide-react'
import { useAway, useSettings } from '@/lib/items'
import { awayLabel, awayWhen, userToday } from '@/lib/plan'
import { useUserNow } from '@/lib/session'
import { attention } from '@/lib/styles'
import { cn } from '@/lib/utils'

/**
 * Header: the user is away now ("Away until Fri 6 Nov") or soon ("Away from Mon 26 Oct", within
 * the user's rule, two weeks by default); it links to the time off in Settings. Phones have no room for the date: they show
 * "Away", and the whole sentence stays the link's name.
 */
export function AwayChip() {
  const away = useAway()
  const settings = useSettings()
  const now = useUserNow(60_000)
  const status = away.data
  if (!status) return null
  // Only for the label: the year is left out in the current year.
  const { year } = userToday(now, settings.data?.timezone ?? 'Europe/Zurich')
  const label = awayLabel(status, year)
  return (
    <Link
      to="/settings/$section"
      params={{ section: 'time-off' }}
      hash="time-off"
      data-testid="away-chip"
      data-state={status.state}
      aria-label={label}
      title={label}
      className={cn(
        'inline-flex h-7 shrink-0 items-center gap-1.5 rounded-full border px-2.5 text-xs font-medium whitespace-nowrap transition-colors outline-none focus-visible:ring-3 focus-visible:ring-ring/50',
        attention.badge,
        attention.hover,
      )}
    >
      <TreePalmIcon aria-hidden="true" className="size-3.5 shrink-0" />
      <span>
        Away<span className="max-sm:hidden"> {awayWhen(status, year)}</span>
      </span>
    </Link>
  )
}
